export const HOME_SECTIONS = [
  { key: "marquee", label: "Destination slider" },
  { key: "festive", label: "Festive band" },
  { key: "creators", label: "Creator trips" },
  { key: "upcoming", label: "Upcoming trips" },
  { key: "specials", label: "Safarshala Specials" },
  { key: "categories", label: "Categories" },
  { key: "departures", label: "Upcoming departures" },
  { key: "why", label: "Why Safarshala" },
  { key: "reviews", label: "Testimonials" },
  { key: "cta", label: "Final call-to-action" },
];

// Merges saved config with defaults so new sections always appear (visible) at the end.
export function normalizeSections(saved) {
  const list = Array.isArray(saved) ? saved.filter((s) => HOME_SECTIONS.some((d) => d.key === s.key)) : [];
  const seen = new Set(list.map((s) => s.key));
  return [...list.map((s) => ({ key: s.key, visible: s.visible !== false })), ...HOME_SECTIONS.filter((d) => !seen.has(d.key)).map((d) => ({ key: d.key, visible: true }))];
}

export const orderedSections = (saved) => normalizeSections(saved).filter((s) => s.visible);
